(() => {
  const config = window.watchPeakTheme || {};

  function formatMoney(cents) {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const format = config.moneyFormat || '{{ amount }}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents || 0) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  }

  function getCartJsonRoute(route) {
    const base = route || '/cart';
    return base.endsWith('.js') ? base : `${base}.js`;
  }

  function getCheckoutRoute() {
    const route = config.routes?.checkout || '/checkout';
    return /^\/[a-z]{2}checkout(?:[/?#]|$)/i.test(route) ? '/checkout' : route;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.setAttribute('aria-label', String(count));
    });
  }

  function initTrackingForms() {
    document.querySelectorAll('[data-tracking-form]').forEach((form) => {
      const input = form.querySelector('[data-tracking-input]');
      const error = form.querySelector('[data-tracking-error]');
      if (!input) return;

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const rawValue = input.value.trim();
        if (!rawValue) {
          if (error) error.hidden = false;
          input.focus();
          return;
        }

        if (error) error.hidden = true;
        const hasUrl = /^https?:\/\//i.test(rawValue);
        const trackingUrl = hasUrl
          ? rawValue
          : `${(document.documentElement.lang || '').startsWith('en')
            ? 'https://www.17track.net/en/tracking'
            : 'https://www.17track.net/fr/tracking'}?nums=${encodeURIComponent(rawValue.replace(/\s+/g, ''))}`;

        window.open(trackingUrl, '_blank', 'noopener,noreferrer');
      });
    });
  }

  async function addProductToCart(form) {
    const response = await fetch(getCartJsonRoute(config.routes?.cartAdd), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add item.');

    const cartResponse = await fetch(getCartJsonRoute(config.routes?.cart), {
      headers: { Accept: 'application/json' },
    });
    return cartResponse.json();
  }

  function selectedOptions(form) {
    const options = [];
    form.querySelectorAll('[data-product-option]').forEach((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      const select = group.querySelector('select');
      options.push(checked ? checked.value : select ? select.value : '');
    });
    return options;
  }

  function setActiveProductMedia(id) {
    document.querySelectorAll('[data-media-id]').forEach((node) => {
      node.hidden = node.dataset.mediaId !== id;
    });
    document.querySelectorAll('[data-media-thumb]').forEach((node) => {
      node.setAttribute('aria-current', node.dataset.mediaThumb === id ? 'true' : 'false');
    });
  }

  function syncProductForm(form) {
    const dataNode = form.querySelector('[data-product-json]');
    const idInput = form.querySelector('input[name="id"]');
    const priceNode = form.querySelector('[data-product-price]');
    const compareNode = form.querySelector('[data-product-compare-price]');
    const errorNode = form.querySelector('[data-product-error]');
    const submit = form.querySelector('[data-add-to-cart]');
    const buyNow = form.querySelector('[data-buy-now]');
    if (!dataNode || !idInput || !submit) return;

    let variants = [];
    try {
      variants = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      return;
    }

    const options = selectedOptions(form);
    const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
    if (!variant) return;

    idInput.value = variant.id;
    submit.disabled = !variant.available;
    submit.querySelector('[data-add-to-cart-text]').textContent = variant.available
      ? config.strings?.addToCart || 'Add to cart'
      : config.strings?.soldOut || 'Sold out';
    if (buyNow) {
      buyNow.disabled = !variant.available;
      buyNow.querySelector('[data-buy-now-text]').textContent = variant.available
        ? config.strings?.buyNow || 'Buy now'
        : config.strings?.soldOut || 'Sold out';
    }

    if (priceNode) priceNode.textContent = formatMoney(variant.price);
    if (compareNode) {
      compareNode.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price)
        : '';
    }
    if (errorNode) errorNode.textContent = '';

    if (variant.featured_media) {
      setActiveProductMedia(String(variant.featured_media.id));
    }
  }

  initTrackingForms();

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('change', () => syncProductForm(form));
    syncProductForm(form);

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !form.dataset.ajaxProductForm) return;
      event.preventDefault();

      const submit = form.querySelector('[data-add-to-cart]');
      const submitText = form.querySelector('[data-add-to-cart-text]');
      const buyNow = form.querySelector('[data-buy-now]');
      const errorNode = form.querySelector('[data-product-error]');
      const originalText = submitText ? submitText.textContent : '';
      submit.disabled = true;
      if (buyNow) buyNow.disabled = true;
      if (submitText) submitText.textContent = config.strings?.adding || 'Adding';
      if (errorNode) errorNode.textContent = '';

      try {
        const cart = await addProductToCart(form);
        updateCartCount(cart.item_count || 0);
        if (submitText) submitText.textContent = config.strings?.added || 'Added';
        window.setTimeout(() => {
          submit.disabled = false;
          if (buyNow) buyNow.disabled = false;
          if (submitText) submitText.textContent = originalText;
        }, 1400);
      } catch (error) {
        submit.disabled = false;
        if (buyNow) buyNow.disabled = false;
        if (submitText) submitText.textContent = originalText;
        if (errorNode) errorNode.textContent = error.message;
      }
    });

    form.querySelector('[data-buy-now]')?.addEventListener('click', async () => {
      if (!window.fetch || !form.dataset.ajaxProductForm) return;

      const submit = form.querySelector('[data-add-to-cart]');
      const buyNow = form.querySelector('[data-buy-now]');
      const buyNowText = form.querySelector('[data-buy-now-text]');
      const errorNode = form.querySelector('[data-product-error]');
      const originalText = buyNowText ? buyNowText.textContent : '';

      submit.disabled = true;
      buyNow.disabled = true;
      if (buyNowText) buyNowText.textContent = config.strings?.buyingNow || 'Opening checkout';
      if (errorNode) errorNode.textContent = '';

      try {
        const cart = await addProductToCart(form);
        updateCartCount(cart.item_count || 0);
        window.location.href = getCheckoutRoute();
      } catch (error) {
        submit.disabled = false;
        buyNow.disabled = false;
        if (buyNowText) buyNowText.textContent = originalText;
        if (errorNode) errorNode.textContent = error.message;
      }
    });
  });

  document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
    const input = selector.querySelector('input');
    if (!input) return;
    selector.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const change = Number(button.dataset.quantityChange || 0);
        const min = Number(input.getAttribute('min') || 0);
        const value = Math.max(min, Number(input.value || 0) + change);
        input.value = String(value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach((field) => {
    field.addEventListener('change', () => field.form?.submit());
  });

  function removeQueryValue(name, value) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const values = params.getAll(name);
    params.delete(name);
    values
      .filter((item) => item !== value)
      .forEach((item) => params.append(name, item));
    url.search = params.toString();
    return url.pathname + url.search;
  }

  function syncManualCollectionFilters() {
    const params = new URLSearchParams(window.location.search);
    const activeFilters = document.querySelector('.active-filters');

    document.querySelectorAll('[data-manual-filter]').forEach((dropdown) => {
      let activeCount = 0;

      dropdown.querySelectorAll('[data-manual-filter-input]').forEach((input) => {
        const isActive = params.getAll(input.name).includes(input.value);
        input.checked = isActive;
        if (!isActive) return;

        activeCount += 1;
        if (!activeFilters) return;

        const key = `${input.name}=${input.value}`;
        const exists = Array.from(activeFilters.querySelectorAll('[data-manual-active-filter]')).some(
          (node) => node.dataset.manualActiveFilter === key,
        );
        if (exists) return;

        const label = input.closest('.filter-option')?.innerText.trim() || input.value;
        const link = document.createElement('a');
        link.className = 'active-filter';
        link.href = removeQueryValue(input.name, input.value);
        link.dataset.manualActiveFilter = key;
        link.textContent = `${label} x`;
        activeFilters.append(link);
      });

      const summary = dropdown.querySelector('.collection-dropdown-trigger');
      let countNode = dropdown.querySelector('.collection-dropdown-count');
      if (!summary) return;

      if (activeCount > 0) {
        if (!countNode) {
          countNode = document.createElement('span');
          countNode.className = 'collection-dropdown-count';
          summary.append(countNode);
        }
        countNode.textContent = String(activeCount);
      } else {
        countNode?.remove();
      }
    });
  }

  function localizeCollectionFilterLabels() {
    const language = (document.documentElement.lang || 'fr').toLowerCase();
    const isFrench = language.startsWith('fr');
    const labels = [
      { match: 'option.color', label: isFrench ? 'Couleur' : 'Color' },
      { match: 'option.size', label: isFrench ? 'Taille' : 'Size' },
      { match: 'custom.public', label: isFrench ? 'Public' : 'Audience' },
    ];

    document.querySelectorAll('.facet[data-collection-dropdown]').forEach((dropdown) => {
      const field = dropdown.querySelector('input[name^="filter."]');
      const summaryLabel = dropdown.querySelector('.collection-dropdown-trigger span:first-child');
      if (!field || !summaryLabel) return;

      const name = (field.name || '').toLowerCase();
      const label = labels.find((item) => name.includes(item.match));
      if (label) summaryLabel.textContent = label.label;
    });
  }

  function initRelatedSliders() {
    const setElementClass = (node, className, enabled) => {
      if (!node) return;
      const classes = String(node.className || '').split(/\s+/).filter(Boolean);
      const hasClass = classes.includes(className);
      if (enabled && !hasClass) classes.push(className);
      if (!enabled && hasClass) classes.splice(classes.indexOf(className), 1);
      node.className = classes.join(' ');
    };

    document.querySelectorAll('[data-related-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-related-track]');
      const previous = slider.querySelector('[data-related-prev]');
      const next = slider.querySelector('[data-related-next]');
      if (!track) return;

      const getStep = () => {
        const firstCard = track.querySelector('.product-card');
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const cardWidth = firstCard?.getBoundingClientRect().width || 0;
        return Math.max(cardWidth + gap, track.clientWidth * 0.75);
      };

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maxScroll > 2;
        setElementClass(slider, 'is-overflowing', hasOverflow);
        if (previous) previous.disabled = !hasOverflow || track.scrollLeft <= 2;
        if (next) next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
      };

      previous?.addEventListener('click', () => {
        track.scrollLeft -= getStep();
        window.setTimeout(update, 220);
      });

      next?.addEventListener('click', () => {
        track.scrollLeft += getStep();
        window.setTimeout(update, 220);
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      window.setTimeout(update, 500);
      window.setTimeout(update, 1600);
    });
  }

  function localizeReviewWidget() {
    const language = (document.documentElement.lang || 'fr').toLowerCase();
    const isEnglish = language.startsWith('en');

    const englishReplacements = [
      ['Avis Clients', 'Customer reviews'],
      ['Soyez le premier \u00e0 \u00e9crire un avis', 'Be the first to write a review'],
      ['\u00c9crire un avis', 'Write a review'],
      ['Ecrire un avis', 'Write a review'],
      ['Aucun avis', 'No reviews yet'],
      ['Sort reviews by', 'Sort reviews by'],
      ['Comment \u00e9valueriez-vous ce produit ?', 'How would you rate this product?'],
      ['Nous serions ravis que vous partagiez un peu votre exp\u00e9rience.', "We'd love to hear about your experience."],
      ['T-Shirt Retro Crew', 'Retro Crew Tee'],
      ['T-shirt Galactic Boss', 'Galactic Boss Tee'],
      ['T-shirt Short King', 'Short King Tee'],
      ['T-Shirt First Class Advisory', 'First Class Advisory Tee'],
      ['T-Shirt Double Vision', 'Double Vision Tee'],
      ['T-Shirt Magic Society', 'Magic Society Tee'],
      ["Contenu de l'avis (Obligatoire)", 'Review content (Required)'],
      ['Commencez \u00e0 \u00e9crire ici...', 'Start writing here...'],
      ['Nous vous contacterons uniquement au sujet de votre avis si n\u00e9cessaire.', 'We will only contact you about your review if needed.'],
      ['En soumettant votre avis, vous acceptez nos', 'By submitting your review, you agree to our'],
      ['et notre', 'and our'],
      ["conditions d'utilisation", 'terms of use'],
      ['politique de confidentialit\u00e9', 'privacy policy'],
      ['\u00c0 propos de vous', 'About you'],
      ['Veuillez nous en dire plus sur vous.', 'Tell us a little more about yourself.'],
      ['Adresse email (Obligatoire)', 'Email address (Required)'],
      ['Votre adresse email', 'Your email address'],
      ['Nous respectons votre vie priv\u00e9e.', 'We respect your privacy.'],
      ["Nom d'affichage (Obligatoire)", 'Display name (Required)'],
      ["Nom d'affichage", 'Display name'],
      ['Ne sera pas visible pour les autres clients.', 'Will not be visible to other customers.'],
      ['Avis anonyme', 'Anonymous review'],
      ['Partager une photo ou une vid\u00e9o', 'Share a photo or video'],
      ['T\u00e9l\u00e9chargez une photo ou une vid\u00e9o pour \u00e9tayer votre avis.', 'Upload a photo or video to support your review.'],
      ['Cliquez pour t\u00e9l\u00e9charger ou glissez-d\u00e9posez', 'Click to upload or drag and drop'],
      ['Cliquez pour t\u00e9l\u00e9charger', 'Click to upload'],
      ['ou glissez-d\u00e9posez', 'or drag and drop'],
      ['Collez votre URL Youtube ici', 'Paste your YouTube URL here'],
      ['Merci pour votre avis !', 'Thanks for your review!'],
      ["Nous le traitons et il appara\u00eetra bient\u00f4t dans la boutique.", 'We are processing it and it will appear in the shop soon.'],
      ["Veuillez confirmer votre email en cliquant sur le lien que nous venons de vous envoyer.", 'Please confirm your email by clicking the link we just sent you.'],
      ['Cela nous aide \u00e0 maintenir des avis authentiques.', 'This helps us keep reviews authentic.'],
      ["Aimeriez-vous partager votre exp\u00e9rience d'achat avec nous ?", 'Would you like to share your shopping experience with us?'],
      ["Nous appr\u00e9cions votre retour d'exp\u00e9rience et nous l'utilisons pour nous am\u00e9liorer.", 'We value your feedback and use it to improve.'],
      ['Veuillez partager vos pens\u00e9es ou suggestions.', 'Please share your thoughts or suggestions.'],
      ['Votre note', 'Your rating'],
      ["Titre de l'avis", 'Review title'],
      ['Votre avis', 'Your review'],
      ['Nom', 'Name'],
      ['Envoyer', 'Submit'],
      ["Envoyer l'avis", 'Submit review'],
      ['Annuler', 'Cancel'],
      ['Retour', 'Back'],
      ['Suivant', 'Next'],
      ['Fermer', 'Close'],
    ];

    const frenchReplacements = [
      ['Avis Clients', 'Avis clients'],
      ['Write a review', '\u00c9crire un avis'],
      ['Customer reviews', 'Avis clients'],
      ['Sort reviews by', 'Trier les avis'],
      ['No reviews yet', 'Aucun avis pour le moment'],
      ['Be the first to write a review', 'Soyez le premier \u00e0 \u00e9crire un avis'],
    ];

    const replacements = new Map(isEnglish ? englishReplacements : frenchReplacements);

    const replacementEntries = Array.from(replacements.entries()).sort((left, right) => right[0].length - left[0].length);
    const normalizedReplacement = (value) => {
      if (!value) return null;
      const normalized = value.trim().replace(/\s+/g, ' ');
      const exact = replacements.get(normalized);
      if (exact) return exact;

      let translated = normalized;
      replacementEntries.forEach(([source, replacement]) => {
        translated = translated.split(source).join(replacement);
      });
      return translated !== normalized ? translated : null;
    };

    const apply = () => {
      document.querySelectorAll('.product-review-app, .jdgm-write-review-modal').forEach((root) => {
        root.querySelectorAll('div, p, button, a, label, span, strong, b, h1, h2, h3, h4, input, textarea').forEach((node) => {
          if (node.matches('script, style')) return;

          const directText = node.childNodes.length > 0 && Array.from(node.childNodes).every((child) => child.nodeType === Node.TEXT_NODE);
          if (directText) {
            const replacement = normalizedReplacement(node.textContent);
            if (replacement && node.textContent.trim() !== replacement) node.textContent = replacement;
          } else {
            node.childNodes.forEach((child) => {
              if (child.nodeType !== Node.TEXT_NODE) return;
              const replacement = normalizedReplacement(child.textContent);
              if (replacement) child.textContent = child.textContent.replace(child.textContent.trim(), replacement);
            });
          }

          const ariaLabel = normalizedReplacement(node.getAttribute('aria-label'));
          if (ariaLabel && node.getAttribute('aria-label') !== ariaLabel) node.setAttribute('aria-label', ariaLabel);

          const placeholder = normalizedReplacement(node.getAttribute('placeholder'));
          if (placeholder && node.getAttribute('placeholder') !== placeholder) node.setAttribute('placeholder', placeholder);

          if (node.tagName === 'INPUT' && ['button', 'submit'].includes(node.type)) {
            const value = normalizedReplacement(node.value);
            if (value && node.value !== value) node.value = value;
          }
        });
      });
    };

    apply();

    const reviewsRoot = document.body || document.querySelector('#product-reviews');
    if (!reviewsRoot || !window.MutationObserver) return;

    let queued = false;
    const queueApply = () => {
      if (queued) return;
      queued = true;
      window.setTimeout(() => {
        queued = false;
        apply();
      }, 50);
    };

    new MutationObserver(queueApply).observe(reviewsRoot, {
      attributes: true,
      attributeFilter: ['aria-label', 'placeholder', 'value'],
      characterData: true,
      childList: true,
      subtree: true,
    });

    window.setTimeout(apply, 1200);
    window.setTimeout(apply, 3200);
  }

  syncManualCollectionFilters();
  localizeCollectionFilterLabels();
  initRelatedSliders();
  localizeReviewWidget();

  async function refreshStaleProductLongform() {
    const currentLongform = document.querySelector('.product-longform');
    if (!currentLongform || document.querySelector('.product-size-guide-card') || !window.fetch) return;

    const sectionWrapper = currentLongform.closest('[id^="shopify-section-template"]');
    const sectionId = sectionWrapper?.id?.replace('shopify-section-', '');
    if (!sectionId) return;

    try {
      const url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshLongform = doc.querySelector('.product-longform');
      if (!freshLongform || !freshLongform.querySelector('.product-size-guide-card')) return;

      currentLongform.replaceWith(freshLongform);
    } catch (error) {
      // Shopify can briefly serve a stale cached product page after theme pushes.
    }
  }

  refreshStaleProductLongform();

  const collectionDropdowns = Array.from(document.querySelectorAll('[data-collection-dropdown]'));
  const localizationDropdowns = Array.from(document.querySelectorAll('[data-localization-dropdown]'));
  const mobileMenus = Array.from(document.querySelectorAll('.mobile-menu'));
  const managedDropdowns = [...collectionDropdowns, ...localizationDropdowns];
  managedDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      managedDropdowns.forEach((otherDropdown) => {
        if (otherDropdown !== dropdown) otherDropdown.open = false;
      });
    });
  });

  document.addEventListener('pointerdown', (event) => {
    const insideManagedDropdown = event.target.closest?.('[data-collection-dropdown], [data-localization-dropdown]');
    const insideMobileMenu = event.target.closest?.('.mobile-menu');

    if (!insideManagedDropdown) {
      managedDropdowns.forEach((dropdown) => {
        dropdown.open = false;
      });
    }

    if (!insideMobileMenu) {
      mobileMenus.forEach((menu) => {
        menu.open = false;
      });
    }
  }, { capture: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    managedDropdowns.forEach((dropdown) => {
      dropdown.open = false;
    });
    mobileMenus.forEach((menu) => {
      menu.open = false;
    });
  });

  document.querySelectorAll('[data-media-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      setActiveProductMedia(button.dataset.mediaThumb);
    });
  });

  document.querySelectorAll('[data-media-zoom]').forEach((button) => {
    let suppressNextClick = false;

    const updateZoomPosition = (event) => {
      const rect = button.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      button.style.setProperty('--media-zoom-x', `${Math.max(0, Math.min(100, x)).toFixed(2)}%`);
      button.style.setProperty('--media-zoom-y', `${Math.max(0, Math.min(100, y)).toFixed(2)}%`);
    };

    const stopTouchZoom = () => {
      button.classList.remove('is-media-zooming', 'is-touch-zooming');
      button.style.removeProperty('--media-zoom-x');
      button.style.removeProperty('--media-zoom-y');
    };

    button.addEventListener(
      'click',
      (event) => {
        if (!suppressNextClick) return;
        suppressNextClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true,
    );

    button.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      button.classList.add('is-media-zooming');
      updateZoomPosition(event);
    });

    button.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse') {
        return;
      }

      button.classList.add('is-media-zooming');
      updateZoomPosition(event);
    });

    button.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      button.classList.remove('is-media-zooming');
      button.style.removeProperty('--media-zoom-x');
      button.style.removeProperty('--media-zoom-y');
    });

    button.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      stopTouchZoom();
      suppressNextClick = false;
    });

    button.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'mouse') return;
      stopTouchZoom();
      suppressNextClick = false;
    });

    button.addEventListener('pointercancel', stopTouchZoom);
    button.addEventListener('lostpointercapture', stopTouchZoom);
  });

  const ensureProductLightbox = () => {
    const existingLightbox = document.querySelector('[data-product-lightbox]');
    if (existingLightbox) {
      if (existingLightbox.parentElement !== document.body) document.body.append(existingLightbox);
      return existingLightbox;
    }
    if (!document.querySelector('[data-lightbox-trigger], .media-zoom-button[href]')) return null;

    const lightbox = document.createElement('div');
    lightbox.className = 'product-lightbox';
    lightbox.dataset.productLightbox = '';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', config.strings?.mediaLightbox || 'Product image preview');
    lightbox.hidden = true;
    lightbox.innerHTML = `
      <button type="button" class="product-lightbox-backdrop" data-lightbox-close aria-label="Close"></button>
      <figure class="product-lightbox-frame">
        <button type="button" class="product-lightbox-close" data-lightbox-close aria-label="Close">x</button>
        <img data-lightbox-image src="" alt="" width="2400" height="2400">
      </figure>
    `;
    document.body.append(lightbox);
    return lightbox;
  };

  const productLightbox = ensureProductLightbox();
  if (productLightbox) {
    const lightboxImage = productLightbox.querySelector('[data-lightbox-image]');
    const closeButton = productLightbox.querySelector('.product-lightbox-close');
    let lastLightboxTrigger = null;

    const closeLightbox = () => {
      productLightbox.hidden = true;
      document.body.classList.remove('watchpeak-lightbox-open');
      if (lightboxImage) {
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
      }
      lastLightboxTrigger?.focus();
    };

    document.querySelectorAll('[data-lightbox-trigger], .media-zoom-button[href]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const source = trigger.dataset.lightboxSrc || trigger.getAttribute('href');
        if (!lightboxImage || !source) return;

        lastLightboxTrigger = trigger;
        lightboxImage.src = source;
        lightboxImage.alt = trigger.dataset.lightboxAlt || trigger.querySelector('img')?.alt || '';
        productLightbox.hidden = false;
        document.body.classList.add('watchpeak-lightbox-open');
        closeButton?.focus();
      });
    });

    productLightbox.querySelectorAll('[data-lightbox-close]').forEach((button) => {
      button.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !productLightbox.hidden) closeLightbox();
    });
  }

  const cookieBanner = document.querySelector('[data-cookie-banner]');
  const hasNativeCookieBanner = () => Boolean(
    window.Shopify?.customerPrivacy
      || document.querySelector('[id^="shopify-pc"], [class*="shopify-pc"]'),
  );
  if (cookieBanner && localStorage.getItem('watchpeak-cookie-consent') == null) {
    const revealFallbackCookieBanner = () => {
      cookieBanner.hidden = hasNativeCookieBanner();
    };
    revealFallbackCookieBanner();

    if (window.MutationObserver) {
      new MutationObserver(revealFallbackCookieBanner).observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }

    window.setTimeout(revealFallbackCookieBanner, 900);
    window.setTimeout(revealFallbackCookieBanner, 2600);
  }
  document.querySelector('[data-cookie-accept]')?.addEventListener('click', () => {
    localStorage.setItem('watchpeak-cookie-consent', 'accepted');
    if (cookieBanner) cookieBanner.hidden = true;
  });
  document.querySelector('[data-cookie-reject]')?.addEventListener('click', () => {
    localStorage.setItem('watchpeak-cookie-consent', 'rejected');
    if (cookieBanner) cookieBanner.hidden = true;
  });
})();
